// if (!customElements.get('media-gallery')) {
//   customElements.define('media-gallery', class MediaGallery extends HTMLElement {
//     constructor() {
//       super();
//       this.elements = {
//         liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//         viewer: this.querySelector('[id^="GalleryViewer"]'),
//         thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
//       }
//       this.mql = window.matchMedia('(min-width: 1040px)');
//       if (!this.elements.thumbnails) return;

//       this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
//       this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//         mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
//       });
//       if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
//     }

//     onSlideChanged(event) {
//       const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
//       this.setActiveThumbnail(thumbnail);
//     }

//     setActiveMedia(mediaId, prepend) {
//       const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
//       this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
//         element.classList.remove('is-active');
//       });
//       activeMedia.classList.add('is-active');

//       if (prepend) {
//         activeMedia.parentElement.prepend(activeMedia);
//         if (this.elements.thumbnails) {
//           const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
//           activeThumbnail.parentElement.prepend(activeThumbnail);
//         }
//         if (this.elements.viewer.slider) this.elements.viewer.resetPages();
//       }

//       this.preventStickyHeader();
//       window.setTimeout(() => {
//         if (this.elements.thumbnails) {
//           activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
//         }
//         if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
//           activeMedia.scrollIntoView({behavior: 'smooth'});
//         }
//       });
//       this.playActiveMedia(activeMedia);

//       if (!this.elements.thumbnails) return;
//       const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
//       this.setActiveThumbnail(activeThumbnail);
//       this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
//     }

//     setActiveThumbnail(thumbnail) {
//       if (!this.elements.thumbnails || !thumbnail) return;

//       this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
//       thumbnail.querySelector('button').setAttribute('aria-current', true);
//       if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

//       this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
//     }

//     announceLiveRegion(activeItem, position) {
//       const image = activeItem.querySelector('.product__modal-opener--image img');
//       if (!image) return;
//       image.onload = () => {
//         this.elements.liveRegion.setAttribute('aria-hidden', false);
//         this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
//           '[index]',
//           position
//         );
//         setTimeout(() => {
//           this.elements.liveRegion.setAttribute('aria-hidden', true);
//         }, 2000);
//       };
//       image.src = image.src;
//     }

//     playActiveMedia(activeItem) {
//       window.pauseAllMedia();
//       const deferredMedia = activeItem.querySelector('.deferred-media');
//       if (deferredMedia) deferredMedia.loadContent(false);
//     }

//     preventStickyHeader() {
//       this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//       if (!this.stickyHeader) return;
//       this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//     }

//     removeListSemantic() {
//       if (!this.elements.viewer.slider) return;
//       this.elements.viewer.slider.setAttribute('role', 'presentation');
//       this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
//     }
//   });
// }

// Product Gallery Navigation with Thumbnails and Looping
class ProductGalleryController {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.mediaGallery = document.querySelector(`#MediaGallery-${sectionId}`);
    this.mainSlider = document.querySelector(`#Slider-Gallery-${sectionId}`);
    this.thumbnailSlider = document.querySelector(`#Slider-Thumbnails-${sectionId}`);
    this.thumbnailContainer = document.querySelector(`#GalleryThumbnails-${sectionId}`);
    
    if (!this.mainSlider) return;
    
    // Check if already initialized
    if (this.mediaGallery && this.mediaGallery.dataset.galleryInitialized === 'true') {
      return;
    }
    
    // Mark as initialized
    if (this.mediaGallery) {
      this.mediaGallery.dataset.galleryInitialized = 'true';
    }
    
    // Get only the buttons within the thumbnail container
    this.prevButtons = this.thumbnailContainer ? Array.from(this.thumbnailContainer.querySelectorAll('.opana-prev')) : [];
    this.nextButtons = this.thumbnailContainer ? Array.from(this.thumbnailContainer.querySelectorAll('.opana-next')) : [];
    
    this.slides = Array.from(this.mainSlider.querySelectorAll('.product__media-item'));
    this.thumbnails = this.thumbnailSlider ? Array.from(this.thumbnailSlider.querySelectorAll('.thumbnail-list__item')) : [];
    this.currentIndex = 0;
    
    this.init();
  }
  
  init() {
    // Find initial active slide
    const activeSlide = this.mainSlider.querySelector('.is-active');
    if (activeSlide) {
      this.currentIndex = this.slides.indexOf(activeSlide);
    }
    
    // Bind navigation buttons with capture phase
    this.prevButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.navigate(-1);
      }, true);
    });
    
    this.nextButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.navigate(1);
      }, true);
    });
    
    // Bind thumbnail clicks
    this.thumbnails.forEach((thumb, idx) => {
      const button = thumb.querySelector('button');
      if (button) {
        // Make sure this button is not a nav button
        if (!button.classList.contains('slider-button') && 
            !button.closest('.slider-button')) {
          button.addEventListener('click', () => {
            this.goToSlide(idx);
          });
        }
      }
    });
    
    // Sync initial state
    this.updateActiveStates();
  }
  
  navigate(direction) {
    // Calculate new index with looping
    let newIndex = this.currentIndex + direction;
    
    if (newIndex < 0) {
      newIndex = this.slides.length - 1;
    } else if (newIndex >= this.slides.length) {
      newIndex = 0;
    }
    
    this.goToSlide(newIndex);
  }
  
  goToSlide(index) {
    if (index < 0 || index >= this.slides.length) return;
    
    this.currentIndex = index;
    this.updateActiveStates();
  }
  
  updateActiveStates() {
    // Update main slider
    this.slides.forEach((slide, idx) => {
      if (idx === this.currentIndex) {
        slide.classList.add('is-active');
      } else {
        slide.classList.remove('is-active');
      }
    });
    
    // Update thumbnails
    this.thumbnails.forEach((thumb, idx) => {
      const button = thumb.querySelector('button');
      if (button) {
        if (idx === this.currentIndex) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      }
    });
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  const galleries = document.querySelectorAll('[id^="MediaGallery-"]');
  
  galleries.forEach(gallery => {
    const sectionId = gallery.id.replace('MediaGallery-', '').replace('-duplicate', '');
    new ProductGalleryController(sectionId);
  });
});